export const obtenerCampo = (error) => {
  if (!error) return {};
  const [firstError] = error;
  const fieldName = firstError?.name?.[0];
  if (!fieldName) return {};
  return fieldName;
};

export const scrollToErrorField = (errors, formRef) => {
  const fieldName = obtenerCampo(errors);
  if (fieldName) {
    formRef.scrollToField(fieldName, {
      behavior: 'smooth', // Opcional: define cómo se realiza el desplazamiento
      block: 'center' // Opcional: define cómo se centra el campo en la vista
    });
    return fieldName;
  }
  return [];
};
